import { Box, Text, HStack, Flex, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'
import BenefitMobile from './benefit-mobie'

const ProductCard01 = () => {
  const productData = {
    titleJP: '保持血管畅通 增加血管弹性',
    titleEN: 'Keep blood vessels open and increase blood vessel elasticity',
    subTitle: '有血净，无三高 / There is Blood Clean, no ‘three highs’',
    descJP: `调节三高正常，保持血管畅通，增加血管柔韧性、弹性，预防血管破裂，解除中风隐患，含珍贵植物武靴藤，100%天然草本成份，无西药添加，无副作用！`,
    descEN: `Regulate the 'three highs' to normal levels, ensure clear blood vessels, and enhance its flexibility and elasticity to prevent rupture and reduce stroke risk. Our formula features the precious plant Gymnema, featuring 100% natural herbal ingredients, with no additions of Western pharmaceuticals and absolutely no side effects!`,
    imageUrl:
      'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-1-1734075592408.png',
    benifit:
      'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/be-1-1731438361788.png'
  }

  const benefitData = [
    {
      ratio: 554 / 218,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item1-1-1731600337646.png',
      className: 'ml-[-6px]'
    },
    {
      ratio: 502 / 214,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item1-2-1731601371560.png'
    },
    {
      ratio: 502 / 212,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item1-3-1731600337648.png'
    }
  ]

  return (
    <Flex
      flexDir={{
        base: 'column',
        lg: 'row'
      }}
      justifyContent="space-between"
      pt={{
        base: '50px',
        lg: '105px'
      }}
      pb="80px"
      id="vascula-health"
    >
      <Box
        w={{
          base: '100%',
          lg: '50%'
        }}
        ml={{
          base: '0',
          lg: '-10%'
        }}
        position="relative"
      >
        <AspectRatio ratio={1327 / 1288} w="100%">
          <Image src={productData.imageUrl} alt={productData.titleEN} fill />
        </AspectRatio>
      </Box>

      <Box
        w={{
          base: '100%',
          lg: '60%'
        }}
      >
        {/* Title and Subtitle */}
        <Box
          w="100%"
          maxW={{
            base: '100%',
            lg: '650px'
          }}
        >
          <Text textStyle="supplementProductCardTitleJP">
            {productData.titleJP}
          </Text>

          <Text textStyle="supplementProductCardTitleEN" mt={1}>
            {productData.titleEN}
          </Text>

          <Text
            textStyle="supplementProductCardSubTitle"
            bg="#9cb25a"
            w={{
              base: 'auto',
              md: 'max-content'
            }}
            mt={5}
            color="white"
            px={2}
            py={1}
          >
            {productData.subTitle}
          </Text>

          <Text textStyle="supplementProductCardDescJP" mt={5}>
            {productData.descJP}
          </Text>

          <Text textStyle="supplementProductCardDescEN" mt={5}>
            {productData.descEN}
          </Text>
        </Box>

        {/* Benefits */}
        <Box w="100%" mt={5}>
          <AspectRatio
            ratio={640 / 94}
            w="100%"
            display={{
              base: 'none',
              md: 'block'
            }}
          >
            <Image src={productData.benifit} alt="benifit item" fill />
          </AspectRatio>
          <Box
            display={{
              base: 'block',
              md: 'none'
            }}
          >
            <BenefitMobile items={benefitData} />
          </Box>
        </Box>

        {/* Buy Button */}
        <HStack
          justifyContent={{
            base: 'flex-start',
            md: 'flex-start'
          }}
          alignItems="center"
          gap={4}
          mt={5}
        >
          <Link href="https://habbit.sg/products/health-plus-kampo-blood-clean-90s">
            <AspectRatio
              ratio={1537 / 864}
              w={{
                base: '120px',
                sm: '120px',
                md: '140px',
                lg: '160px',
                xl: '160px'
              }}
              _hover={{
                opacity: 0.7
              }}
              mt={3}
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/buy-now-btn-1714038035225.png'
                }
                alt="buy now btn"
                fill
              />
            </AspectRatio>
          </Link>

          <Box
            w={{
              base: '244px',
              xl: '244px'
            }}
            mt={2}
          >
            <AspectRatio ratio={123 / 36} w="100%">
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item1-certificate-1730969831994.png'
                }
                alt="traditional item"
                fill
              />
            </AspectRatio>
          </Box>
        </HStack>
      </Box>
    </Flex>
  )
}

export default ProductCard01
